import { render, staticRenderFns } from "./PrintCareLabel.vue?vue&type=template&id=9dc1d890"
import script from "./PrintCareLabel.vue?vue&type=script&lang=js"
export * from "./PrintCareLabel.vue?vue&type=script&lang=js"
import style0 from "./PrintCareLabel.vue?vue&type=style&index=0&id=9dc1d890&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports